<template>
  <div class="p-4">
    <BaseFlexSpinner v-if="isLoading" />
    <div v-else class="flex justify-between flex-wrap">
      <span class="text-primary font-bold text-xl">Nouveautés</span>
      <BaseButton prepend-icon="mdi-lightbulb-on" density="comfortable" primary @click="openIdeaBox">
        Proposer une idée, une amélioration
      </BaseButton>
    </div>
    <div
      v-for="(release, index) in releases"
      :key="index"
      class="bg-white rounded-lg my-6 p-4"
    >
      <div class="flex flex-row justify-between pb-4">
        <span class="font-bold">Version {{ release.fields.version }}</span>
        <span>{{ $filters.date(release.fields.releaseDate, 'dayOnly') }}</span>
      </div>
      <RichTextRenderer
        :document="release.fields.content"
        :node-renderers="contentfulHelper.renderNodes()"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {contentfulService} from '@/container';
import contentfulHelper from '@/core/helpers/contentfulHelper.js';
import RichTextRenderer from 'contentful-rich-text-vue-renderer';
import BaseButton from "@/core/components/base/BaseButton.vue";
import RoadmapService from "@/roadmap/services/RoadmapService.js";
import useSwr from "@/core/composables/swr/useSwr";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";

const {data: releases, isLoading} = useSwr(
    'contentful/releases',
    () => contentfulService().releases().then((response: any) => response),
    contentfulService().swrConfig()
);

const openIdeaBox = () => {
    window.ipcRenderer.openInBrowser(RoadmapService.url());
};

</script>
